module.exports = __webpack_public_path__ + "img/en.68e61b63.png";